import React from "react";
import {Layout, Menu} from "antd";
import {LogoutOutlined, SettingOutlined, UserOutlined} from "@ant-design/icons";
import {useAuth} from "../context/Auth";
import {useNavigate} from "react-router-dom";
import Storage from "../common/StorageHelper";

const {Header} = Layout;

interface Props {
    selectedKeys: Array<string>;
}

const Navbar = ({selectedKeys}: Props) => {
    const {setUser, user} = useAuth();
    const navigate = useNavigate();

    return (
        <Header style={{padding: 0}}>
            <Menu theme="dark" mode="horizontal"
                  selectedKeys={selectedKeys}
                  style={{justifyContent: "flex-end"}}>
                <Menu.SubMenu key="user-menu" title={user?.name} icon={<UserOutlined style={{fontSize: '1.5em'}}/>}>
                    <Menu.Item key="settings" icon={<SettingOutlined style={{fontSize: '1.4em'}}/>}
                               onClick={() => navigate('/settings', {replace: true})}>
                        Settings
                    </Menu.Item>
                    <Menu.Item key="sign-out" icon={<LogoutOutlined style={{fontSize: '1.4em'}}/>} onClick={() => {
                        setUser(null)
                        Storage.clear()
                    }}>
                        Sign-Out
                    </Menu.Item>
                </Menu.SubMenu>
            </Menu>
        </Header>
    )
}

export default Navbar;
